import React from "react";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";

import DemoFooter from "components/Footers/DemoFooter.js";

const AboutUs = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  return (
    <>
      <div className="about-us section" >
        <div
          style={{
            //backgroundImage: "url(" + require("assets/img/bg.png") + ")",
            backgroundColor:"#3E3C3D",
            
          }}
          className="page-bg"
        >
          <ExamplesNavbar notHome={true} />
          {/* <div className="section about-us"> */}
          <Container>
            <Row>
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm1.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
                <br></br>
                <h3 className="title text-white ">Amenities  <hr style={{color:"#000000"}}/></h3>
                
                
                <div className="detail text-white">
                
                  Meraj Housing society is a project owned<br/> by the Directors of
                  Virk Group of<br/> Industries, which has developed its name<br/> in the
                  filed of manufacturing and <br/>customer service since 1995.
                </div>
              </Col>
            </Row>

            <Row className="my-5" >
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm2.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
              <h3 className="title  text-white">
              <br/> Modern Gated Community <hr/></h3>
                 
                <div className="detail text-white">
                Meraj housing is a completely walled and gated community with effective security 
                system ensuring a secure environment for our residents
                </div>
              </Col>
            </Row>

            <Row className="my-6" >
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm3.jpg") + ")",
                    backgroundColor:"#3E3C3D"
                }}
                className="about-image"
              />
              <Col lg={6}>
                <div className="detail text-white" >
                  <h3><br/>World class retail park:  <hr/></h3>
                  introducing a world class retail park to the city of daska, with international chain of 
                  restaurants, cafes and clothing brands like never before in the city. The retail park 
                  will give a boom to the industrial sector of the city. Residents of meraj housing will 
                  enjoy a truly refined shopping experience with leisure and entertainment activities for 
                  the whole family to enjoy at our retail park<br/>
                  
                 <ul> Retail park features
                   <li>High-speed free Wi-Fi connectivity </li>
                   <li>International chain of restaurants and cafe </li>
                   <li>New shopping brands</li>
                   <li>Entertainment for kids</li>
                   <li>Large open parking space</li>
                 </ul>
                </div>
              </Col>
              
            </Row>

            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm4.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h4><br/>Well designed commercial zone: <hr/></h4>
                The vast commercial zone is designed to house retail shops catering to all daily and specialized 
                needs of the residents. The residents will have access to grocery, meat, vegetables and bakery 
                shops at the convenience of their footsteps in the society.</div>

              </Col>
            </Row>
            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm4.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h4><br/>Flawlessly integrated security system:  <hr/></h4>
                Maintaining a secure environment for our residents is our top most priority.
                We will ensure a secure environment by installing electronic security system,
                which will include 24-hour video surveillance system. We will have a security 
                department with highly trained guards to ensure a safe environment for our residents.

</div>

              </Col>
            </Row>
            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm4.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h4><br/>Grand air-conditioned mosque: <hr/></h4>
                A state of the art, beautifully built mosque with modern exteriors, 
                well equipped with air conditioners so the residents can preform their 
                religious duties peacefully.</div>

              </Col>
            </Row>
            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm4.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h4><br/>Lush green landscaped parks:  <hr/></h4>
                Our society will consist of three open parks, beautifully landscaped and designed for our
                residents to soak in the beauty of nature. Our vision is to provide our residents with a 
                green and serene society ensuring a peaceful environment. </div>

              </Col>
            </Row>
            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newamm/amm4.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h4><br/>Upgraded technology solutions: <hr/></h4>
                Our society will have upgraded technology, fiber optics cable, one wire solution for 
                telephone Internet and entertainment facilitates
                <br></br>
                <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                </div>

              </Col>
            </Row>
            
          </Container>
          {/* </div> */}
          <div
          className={"footer-logo-section content-center"}style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image"
            src={require("assets/img/logo@2x.png")}
          />
          
        </div>
         
          { <DemoFooter/> }
        </div>
      </div>
    </>
  );
};

export default AboutUs;
